const Images = {
  sysup360_colour: "/images/360-colour.png",
  sysup360_logo_white: "/images/360-white.png",
  hero_image: "/images/hero_image.webp",
  logo:"/images/SysUp360-Colour.png",
  logo_white:"/images/SysUp360-white.png",
  // Services section images
  call_center: "/images/call_center.webp",
  ussd_services: "/images/ussd_services.webp",
  networking: "/images/networking.webp",
  ip_pbx_installation_and_management: "/images/ip_pbx_installation_and_management.webp",
  mobile_app_software_development: "/images/mobile_app_software_development.webp",
  wan_internet_disaster_recovery: "/images/wan_internet_disaster_recovery.webp",
  outsourced_it_24_7: "/images/24_7_outsourced_it.webp",
  vps_hosting: "/images/vps_hosting.webp",
  web_design_and_email_hosting: "/images/web_design_and_email_hosting.webp",
  our_solutions_and_services: "/images/our_solutions_and_services.webp",
  our_story: "/images/our_story.webp",
};

export default Images;